<script setup>
import Buttons from '@/components/ui/Buttons.vue';
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data.background_color}` : '',
      data?.spacing?.top
        ? `section--top-${data.spacing.top}`
        : 'section--top-xl',
      data?.spacing?.bottom
        ? `section--bottom-${data.spacing.bottom}`
        : 'section--bottom-xl',
      data?.background_color === 'black' ? 'white' : '',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div
        :class="[
          data?.background_color
            ? `title-text-block title-text-block--${data?.background_color}`
            : 'title-text-block',
        ]"
      >
        <h2
          v-if="data.title && data.title.length > 0"
          class="mb-0 title-text-block__title h2"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data.title"
        ></h2>
        <div
          v-if="data.description && data.description.length > 0"
          class="title-text-block__description body-1-regular"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data.description"
        ></div>
        <Buttons
          v-if="data.buttons && data.buttons.length > 0"
          class="title-text-block__buttons"
          :buttons="data?.buttons"
          :background-color="data?.background_color"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          :buttons-prefix-class="'js-button-title-text-block'"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.title-text-block {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  padding: 80px 16px;
  text-align: center;
  @include media-breakpoint-up(sm) {
    padding: 80px 24px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(padding-top, 80);
    @include responsive-spacing(padding-left, 24);
    @include responsive-spacing(padding-right, 24);
    @include responsive-spacing(padding-bottom, 80);
    @include responsive-spacing(border-radius, 8);
    @include responsive-spacing(gap, 48);
  }
  &--white {
    background-color: $gray;
  }
  &--black {
    background-color: rgba($surface-container-opacity, 0.5);
  }
  &--gray {
    background-color: $white;
  }
  &__description {
    &:deep(p:last-child) {
      margin: 0;
    }
    @include media-breakpoint-up(sm) {
      max-width: 86%;
    }
    @include media-breakpoint-up(md) {
      max-width: 66.3%;
    }
  }
  &__buttons {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    @include media-breakpoint-up(sm) {
      flex-direction: row;
      gap: 16px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 16);
    }
  }
}
</style>
